<template>
  <div>
    <label v-if="label" for="inputId" class="mb-2">{{ label }}</label>
    <textarea
      class="form-control"
      :id="inputId"
      :value="modelValue"
      @input="e => $emit('update:modelValue', e.target.value)"
      :rows="rows"
      max-rows="20"
      ref="textarea"
      :maxlength="maxLength"
      v-dynamic-height="{ minHeight, disabled: !useDynamicHeight }"
      :placeholder="placeholder"
    >
    </textarea>
    <small v-if="showTextLength" class="words-counter mt-2 mb-0">
      {{ valueLength }}/{{ maxLength }}
    </small>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 500,
    },
    rows: {
      type: Number,
      default: 5,
    },
    useDynamicHeight: {
      type: Boolean,
      default: true,
    },
    showTextLength: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      type: String,
      default: '66px',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputName() {
      return this.name || this.label || 'input-id';
    },
    inputId() {
      return this.inputName.toLowerCase().replaceAll(' ', '-');
    },
    valueLength() {
      return this.modelValue?.length || 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
.form-control {
  resize: none;
}

.words-counter {
  display: flex;
  justify-content: flex-end;
}
</style>
